import { useMemo } from 'react';
import { useCrossReferenceStore } from 'store/useCrossReferenceStore';
import type { CrossReferenceCellKey } from './types';
import { computeMatchColor, type CrossReferenceMatchColor } from './utils/matchStatus';

// Hook returns the current icon color ('gray' | 'red' | 'green') for a cell
// based on its cross-ref state vs its host cell value. Re-evaluates live as
// either the state or the host value changes. See design spec §8.4.
const useCrossReferenceMatch = (
  cellKey: CrossReferenceCellKey,
  hostValue: number | null | undefined
): CrossReferenceMatchColor => {
  const state = useCrossReferenceStore(store => store.states[cellKey]);
  return useMemo(() => computeMatchColor(hostValue, state), [hostValue, state]);
};

export default useCrossReferenceMatch;
